(function(){
    'use strict'

    angular
    .module('app.grupos')
    .controller('EditarGrupo', EditarGrupo);

    EditarGrupo.$inject = ['$scope', '$animationsSrv', '$routeParams', 'GruposService', 'logger', '$location', 'UserInfoService'];

    function EditarGrupo($scope, $animationsSrv, $routeParams, GruposService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.grupo;

        var grupoId = $routeParams.id ? $routeParams.id : 0;

        getGrupo();

        function getGrupo(){

            if(grupoId != 0){
                var promise = GruposService.getById(grupoId);

                promise
                .then(function(grupo){
                    vm.grupo = grupo;
                })
                .catch(function(error){
                    logger.error('Hubo un erro al obtener los datos');
                });               
            }

        };

        vm.save = function(){             
            $scope.submitted = true;

            if($scope.grupoForm.$valid){
                if(!vm.grupo.id){
                    saveGrupo();
                }
                else if($scope.grupoForm.$dirty){
                    updateGrupo();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }
        };

        function saveGrupo(){
            vm.grupo.id = 0;

            var promise = GruposService.save(vm.grupo);
            
            promise
            .then(function(response){
                logger.success('Grupo creado con éxito.');
                clearGrupoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un erro al crear el grupo'  + error.data.Message);
                        break;
                }
            });  
        };

        function updateGrupo(){

            var promise = GruposService.update(vm.grupo);
            
            promise
            .then(function(response){
                logger.success('Grupo modificado con éxito.');
                $location.path('/grupos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un erro al modificar el grupo: ' + error.data.Message);
                        break;
                }
            });  
        };

        function clearGrupoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.grupo = {};
            // Set back to pristine.
            $scope.grupoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.grupoForm.$setUntouched();
        }

    }
})();